import React from "react";
import { Grid, Typography, Stack } from "@mui/material";
import { Link } from "react-router-dom";

export default function FeaturedProject({ id, name, type, overview }) {
  return (
    <Grid container item key={id} borderBottom="#7070702d solid 2px" xs={8}>
      <Grid item xs={9}>
        <Stack>
          <Typography fontSize="15px">{name}</Typography>
          <Typography fontSize="13px">
            {overview ? overview : "No project overview"}
          </Typography>
        </Stack>
      </Grid>
      <Grid container item xs={3} justifyContent="flex-end">
        <Link
          to={`/project/${id}`}
          state={{ id: id }}
          style={{
            color: "#707070",
            textDecoration: "none",
            fontSize: "13px",
          }}
        >
          View
        </Link>
      </Grid>
    </Grid>
  );
}
